import { renderConfig } from '../../constants';
import { ep } from '../../diagram/numbers';

type Props = {
  isHighlighted: boolean;
  boundingRect: { x: number; y: number; w: number; h: number };
};

// Use each label's size to make custom round-rects underneath.
const SankeyLabelBackground: React.FC<Props> = ({
  isHighlighted,
  boundingRect,
}) => {
  const otherProps = isHighlighted
    ? renderConfig.textBackground.highlighted
    : renderConfig.textBackground.normal;

  return (
    <rect
      x={ep(boundingRect.x)}
      y={ep(boundingRect.y)}
      width={ep(boundingRect.w)}
      height={ep(boundingRect.h)}
      {...otherProps}
    />
  );
};

export default SankeyLabelBackground;
